enum LotSoldStatuses {
  NONE = "None",
  PREPARED = "Prepared",
  SOLD = "Sold",
  UNSOLD = "Unsold"
}

export default LotSoldStatuses;
